const hasDOM = typeof document !== 'undefined';
const target = hasDOM ? window : {};

export {
  target
};
